import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';

import { AuthService } from '../../../services/auth/auth.service';
import { PlanService } from '../../../services/billing/plan.service';
import { ValidationMessageService } from '../../../services/validation-message.service';

import { ErrorClassWhenInvalidModule } from '../../../directives/error-class-when-invalid/error-class-when-invalid.module';
import { RangeBarSelectorModule } from '../../shared/range-bar-selector/range-bar-selector.module';
import { StringValidatorsModule } from '../../../directives/validators/string/string-validators.module';
import { TransformPhoneNoPipe } from '../../../pipes/format/transform-phone-no.pipe';
import { TransformPhoneNoPipeModule } from '../../../pipes/format/transform-phone-no.module';
import { LegfiCurrencyPipeModule } from '../../../pipes/format/legfi-currency.module';
import { LegfiCurrencyPipe } from '../../../pipes/format/legfi-currency.pipe';
import { AdminSignupComponent } from './admin-signup.component';
import { ModalService } from '../../../services/modal.service';
import { MatDialogModule } from '@angular/material/dialog';
import { RecaptchaModule } from 'ng-recaptcha';

@NgModule({
    imports: [
        // Shared
        SharedModule,
        // Dependencies
        ErrorClassWhenInvalidModule,
        LegfiCurrencyPipeModule,
        TransformPhoneNoPipeModule,
        RangeBarSelectorModule,
        RecaptchaModule,
        StringValidatorsModule,
        SharedModule,
        MatDialogModule,
    ],
    declarations: [AdminSignupComponent],
    providers: [
        // Services
        AuthService,
        LegfiCurrencyPipe,
        ModalService,
        PlanService,
        ValidationMessageService,
        // Pipes
        TransformPhoneNoPipe,
    ],
})
export class AdminSignupModule
{
}
